<div class="secondary-toolbar" [ngClass]="{ 'secondary-toolbar-compact': compactSidebar }" id="breadcrumb" #toolbarContainer>
  <div class="new-breadcrumb-container" #breadcrumbContainer>

    <ng-container *ngFor="let parent of parents">
      <a class="new-breadcrumb-link" [uiSref]="parent.uiSref" [uiParams]="parent.uiParam">
        {{ parent.name }}
      </a>
      <span class="new-breadcrumb-separator">/</span>
    </ng-container>

    <span class="new-breadcrumb-current">
      {{ self }}
    </span>

  </div>

  <span class="spacer"></span>

  <div class="action-buttons">
    <app-secondary-toolbar-button
      *ngFor="let act of visibleActions"
      [titleStringKey]="act.titleStringKey"
      [iconClass]="act.iconClass"
      appPreventDoubleClick
      [@buttonFadeScale]
      (click)="act.action()">
    </app-secondary-toolbar-button>

    <ng-container *ngIf="hiddenActions.length > 0">
      <button mat-icon-button [matMenuTriggerFor]="overflowMenu" class="more-button">
        <mat-icon>more_vert</mat-icon>
      </button>

      <mat-menu #overflowMenu="matMenu" xPosition="before" class="applion-more-menu">
        <button appPreventDoubleClick mat-menu-item *ngFor="let act of hiddenActions" (click)="act.action()" class="more-dropdown-item">
          <mat-icon *ngIf="act.iconClass" [ngClass]="act.iconClass" class="icomoon"></mat-icon>
          <span>{{ act.titleStringKey | translate }}</span>
        </button>
      </mat-menu>
    </ng-container>
  </div>
</div>
<div class="secondary-toolbar-placeholder"></div>

<div class="measurement-layer" #measurementLayer aria-hidden="true">
  <app-secondary-toolbar-button
    *ngFor="let act of actions"
    [titleStringKey]="act.titleStringKey"
    [iconClass]="act.iconClass">
  </app-secondary-toolbar-button>
</div>
